import axiosClient from 'lib/axiosClient';
import { useSnackbar } from 'notistack';
import { useState } from 'react';

const useUserRoleList = () => {
  const [loading, setLoading] = useState(true);
  const [roleList, setRoleList] = useState([]);
  const [pageRef, setPageRef] = useState('');

  const { enqueueSnackbar } = useSnackbar();

  const getUserRoleList = ({ Guid, Page, Count }) => {
    setLoading(true);

    axiosClient
      .get('SettingAccount/User/Role/List', {
        params: { Guid, Page, Count },
      })
      .then(res => {
        if (res.status === 200) {
          setPageRef(res.data.value);

          setRoleList(prev => {
            const orderedList = res.data.value.list.map(element => ({
              id: element.roleGuid,
              display: element.display,
            }));

            return { ...prev, [Page || 1]: orderedList };
          });
        } else {
          enqueueSnackbar(res?.message, { variant: 'error' });
        }
      })
      .catch(err => enqueueSnackbar(err?.message, { variant: 'error' }))
      .finally(() => setLoading(false));
  };

  return { getUserRoleList, loading, roleList, pageRef };
};

export default useUserRoleList;
